import $ from 'jquery';
import Api from "../util/Api";
import Popup from "../util/Popup";
import BasketService from "./BasketService";

const giftCache = new Map();

/**
 * Методы existHtmlGift, htmlGiftItemPlus, htmlGiftItemMinus, htmlGiftBxRender работают если на странице есть корзина битрикса с включенным модулем подарков
 * @type {{htmlGiftItemMinus(*): void, htmlGiftBxRender(): void, getPriceBasketRule(): Promise<AxiosResponse<*>>, printGift(): *, htmlGiftItemPlus(*): void, existHtmlGift(): (boolean), render(): void}}
 */
const GiftService = {
    /**
     * @return {*}
     * Проверяет на наличие подарка
     * Если подарок есть, возвращает его html
     */
    printGift(productId) {
        return Api.post('/api/discounts/gift/render/', {
            productId: productId
        });
    },

    /**
     * Проверяет баллы товара, который является подарком
     * @param itemId int ID товара
     * @param searchParam string Определяет по какому полю искать. По BASKET_ID или PRODUCT_ID
     * @returns {Promise<AxiosResponse<*>>}
     */
    printPoints(itemId, searchParam = 'PRODUCT_ID') {
        return Api.post('/api/discounts/gift/points/', {
            itemId: itemId,
            searchParam: searchParam,
        });
    },

    getPriceBasketRule() {
        return Api.post('/api/discounts/gift/getPriceBasketRule/', {})
    },

    existHtmlGift() {
        if ($('.sale-products-gift .product-item-small-card').length > 0)
            return true;

        return false;
    },

    htmlGiftItemPlus(context) {
        if ($('.basket-item-amount-btn-plus').length > 0) {
            const productName = context.parents('.cart-item').find('.cart-item__title').text().trim();

            const $bxBasket = $('#basket-root');
            const items = $bxBasket.find('tbody');

            items.find('.basket-items-list-item-container').each(function (index, element) {
                const nameItemBx = $(element).find('.basket-item-info-name').find('span').text().trim();

                if (nameItemBx == productName) {
                    $(element).find('.basket-item-amount-btn-plus')[0].click();
                }
            });
        }
    },

    htmlGiftItemMinus(context) {
        if ($('.basket-item-amount-btn-minus').length > 0) {
            const productName = context.parents('.cart-item').find('.cart-item__title').text().trim();

            const $bxBasket = $('#basket-root');
            const items = $bxBasket.find('tbody');

            items.find('.basket-items-list-item-container').each(function (index, element) {
                const nameItemBx = $(element).find('.basket-item-info-name').find('span').text().trim();

                if (nameItemBx == productName) {
                    $(element).find('.basket-item-amount-btn-minus')[0].click();
                }
            });
        }
    },

    htmlGiftBxRender() {
        const $bxBasket = $('#basket-root');
        const items = $bxBasket.find('tbody');
        let bxItems = new Map();

        setTimeout(() => {
            function appendDecimalIfNeeded(value) {
                if (!value.includes('.')) {
                    return `${value}.00`;
                }
                return value;
            }

            items.find('.basket-items-list-item-container').each(function (index, element) {
                const productIdItemBx = $(element).attr('data-id');
                const priceItemBx = $(element).find('.basket-items-list-item-price-for-one .basket-item-price-current-text').text().trim().slice(0, -4).trim();
                const fullPriceItemBx = $(element).find('.basket-items-list-item-remove').prev().find('.basket-item-price-current-text').text().trim().slice(0, -4).trim();

                let sanitizedPrice = priceItemBx.replace(/[^0-9.,]/g, '').replace(',', '.');
                let sanitizedFullPrice = fullPriceItemBx.replace(/[^0-9.,]/g, '').replace(',', '.');

                sanitizedPrice = appendDecimalIfNeeded(sanitizedPrice);
                sanitizedFullPrice = appendDecimalIfNeeded(sanitizedFullPrice);

                bxItems.set(productIdItemBx, {
                    priceItemBx: sanitizedPrice,
                    fullPriceItemBx: sanitizedFullPrice
                });
            });



            bxItems.forEach(function (element, productIdItemBx, array) {
                $('.cart-item--' + productIdItemBx).attr('data-price', Object.values(element)[0]);
                $('.cart-item--' + productIdItemBx).attr('data-price-discount', Object.values(element)[0]);
                $('.cart-item--' + productIdItemBx).find('.cart-item__price').html(BasketService.formatPrice(Object.values(element)[0]));
                $('.cart-item--' + productIdItemBx).find('.cart-item__total-price').html(BasketService.formatPrice(Object.values(element)[1]));
            });

            // Обработка итоговой цены с учетом копеек
            const fullBasketSumBx = $bxBasket.find('.basket-coupon-block-total-price-current').text().trim().slice(0, -4).trim();

            // Убираем лишние символы, заменяем запятую на точку
            const sanitizedFullBasketSumBx = fullBasketSumBx.replace(/[^0-9.,]/g, '').replace(',', '.');

            $('.cart-result-amount__value--price-discount').html(BasketService.formatPrice(sanitizedFullBasketSumBx));
        }, 1500);
    },

    render() {
        if (window.location.pathname == '/basket/') {
            setTimeout(() => {
                if (GiftService.existHtmlGift()) {
                    if (giftCache.has('giftHtml')) {
                        Popup.showWithContent(giftCache.get('giftHtml'), 600);
                    } else {
                        GiftService.printGift().then((response) => {
                            if (response.isgift === false) return;

                            giftCache.set('giftHtml', response);

                            Popup.showWithContent(response, 600);
                        });
                    }
                }
            }, 1500);
        }
    }
};
export default GiftService;
